/* cjl-collection.js — filtro en página por familia (build colección · medidas-build §06).
   Chips de la cabecera (data-cjl-filter) muestran/ocultan las cards (data-cjl-fam) del grid.
   Corte seco: toggle de `hidden`, sin reflow animado. La URL no cambia (la URL de familia es su colección).
   Contador "N of M scents" al filtrar; "All" restaura y recupera su placa. Vanilla, sin GSAP, init por instancia. */
(function () {
  'use strict';
  function init(bar) {
    if (bar.dataset.cjlInit) return;
    bar.dataset.cjlInit = '1';
    var chips = bar.querySelectorAll('[data-cjl-filter]');
    var count = bar.querySelector('[data-cjl-count]');
    var tpl = bar.getAttribute('data-cjl-count-template') || '{n} of {m} scents';
    if (count) {
      var all = document.querySelectorAll('[data-cjl-grid] [data-cjl-fam]').length;
      count.hidden = false; /* "Showing 6 of 6 scents" desde el load (spec quickadd) */
      count.textContent = tpl.replace('{n}', all).replace('{m}', all);
    }
    function apply(fam) {
      var cards = document.querySelectorAll('[data-cjl-grid] [data-cjl-fam]');
      var n = 0;
      for (var i = 0; i < cards.length; i++) {
        var show = fam === 'all' || cards[i].getAttribute('data-cjl-fam') === fam;
        cards[i].hidden = !show;
        if (show) n++;
      }
      for (var j = 0; j < chips.length; j++) {
        var on = chips[j].getAttribute('data-cjl-filter') === fam;
        chips[j].classList.toggle('is-active', on);
        chips[j].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      bar.classList.toggle('is-filtered', fam !== 'all');
      var tile = document.querySelector('[data-cjl-set-tile]');
      if (tile) tile.hidden = fam !== 'all';
      if (count) {
        count.hidden = false; /* quickadd spec: "Showing N of M" siempre visible */
        count.textContent = tpl.replace('{n}', n).replace('{m}', cards.length);
      }
    }
    for (var k = 0; k < chips.length; k++) {
      chips[k].addEventListener('click', function () { apply(this.getAttribute('data-cjl-filter')); });
    }
  }
  function boot(root) {
    var bars = (root || document).querySelectorAll('[data-cjl-filterbar]');
    for (var i = 0; i < bars.length; i++) init(bars[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* Quick add (build-package-quickadd, 18 sep): el boton vive dentro del <a> de la card;
   se corta la navegacion y se agrega la variante unica -> drawer aprobado (mismo patron
   que el cross-sell de cjl-cart.js: cart/add.js -> eurus:cart:reload -> openCart). */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.cjl-card__quickadd[data-cjl-atc], .cjl-trio__add[data-cjl-atc], .cjl-lu2__cta[data-cjl-atc], .cjl-ugc__add[data-cjl-atc], .cjl-buy__pairadd[data-cjl-atc]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('data-cjl-busy')) return;
    btn.setAttribute('data-cjl-busy', '1');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-cjl-atc'), 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (window.Alpine && window.Alpine.store && window.Alpine.store('xMiniCart')) {
          window.Alpine.store('xMiniCart').openCart();
        }
        document.dispatchEvent(new CustomEvent('eurus:cart:reload'));
      })
      .finally(function () { btn.removeAttribute('data-cjl-busy'); });
  }, true);
})();

/* Mini-galería táctil dentro de la card (owner 4 oct, ref. SdJ): <990px y solo en contenedores
   [data-cjl-gallery] (best sellers, grid de colección). El dedo pasa packshot → bodegón (el hover)
   → foto con mano (mismos assets que la ficha). Sin fotos de prueba en la card, no se monta.
   Estilos: .cjl-card__strip / __frame / __fdots en cjl-collection.css. */
(function () {
  'use strict';
  var MOBILE = window.matchMedia('(max-width: 989px)');

  function mount(card) {
    if (card.dataset.cjlGal) return;
    var field = card.querySelector('.cjl-card__field');
    var shot = card.querySelector('.cjl-card__shot--cutout');
    var hover = card.querySelector('.cjl-card__hoverimg');
    if (!field || !shot || !hover) return;
    card.dataset.cjlGal = '1';
    var strip = document.createElement('span');
    strip.className = 'cjl-card__strip';
    var f1 = document.createElement('span');
    f1.className = 'cjl-card__frame';
    f1.appendChild(shot);
    var f2 = document.createElement('span');
    f2.className = 'cjl-card__frame';
    hover.className = ''; hover.removeAttribute('style');
    f2.appendChild(hover);
    strip.appendChild(f1); strip.appendChild(f2);
    /* Foto de la mano solo si el contenedor lo pide (ajuste "Mobile: foto de la mano en la card",
       15 oct: apagado mientras llegan las fotos nuevas). */
    var withHand = !!card.closest('[data-cjl-hand]');
    if (withHand) {
      var f3 = document.createElement('span');
      f3.className = 'cjl-card__frame';
      var hand = shot.querySelector('img').getAttribute('src').replace(/-packshot\.png[^"]*/, '-hand.webp');
      f3.innerHTML = '<img src="' + hand + '" loading="lazy" alt="">';
      strip.appendChild(f3);
    }
    var dots = document.createElement('span');
    dots.className = 'cjl-card__fdots';
    dots.setAttribute('aria-hidden', 'true');
    dots.innerHTML = '<i class="is-on"></i><i></i>' + (withHand ? '<i></i>' : '');
    field.appendChild(strip);
    field.appendChild(dots);
    strip.addEventListener('scroll', function () {
      var i = Math.round(strip.scrollLeft / strip.clientWidth);
      dots.querySelectorAll('i').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }, { passive: true });
  }

  function boot(scope) {
    if (!MOBILE.matches) return;
    (scope || document).querySelectorAll('[data-cjl-gallery] .cjl-card').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
